// s3 이미지 주소 관리가 어려워서 만들었어요.
export const IMAGE_ASSETS = {
  AGE_19_THUMB:
    '//s3.marpple.co/files/u_2232571/2025/7/original/dfa96183cedaa4545466331b7bd5f93a206d330a2.png',
  AGE_18_THUMB:
    '//s3.marpple.co/files/u_2232571/2025/7/original/b73861a4cef9448e27edf4a159c44d9f2dbab92a1.png',
  ERROR_THUMB:
    '//s3.marpple.co/files/u_2232571/2025/7/original/e3a5aa2366a427e034022ef282bfe901e9f5f1941.png',

  DEFAULT_PRODUCT_EMPTY_SCREEN:
    '//s3.marpple.co/files/u_2232571/2024/6/original/a57e2be49b0b2c16047dc905043fa2e5c9fbff141.png',
  CREATOR_PRODUCT_EMPTY_SCREEN:
    '//s3.marpple.co/files/u_218933/2024/5/original/b1a00d53c82603359c6aa95ee43f940c832a4dbc1.png',
} as const;
